// 2020 - 2021
import A1 from "../../assets/gallery/FY-20-21/1.png"
import A2 from "../../assets/gallery/FY-20-21/2.png"
import A3 from "../../assets/gallery/FY-20-21/3.png"
import A4 from "../../assets/gallery/FY-20-21/4.png"
import A5 from "../../assets/gallery/FY-20-21/5.png"
import A6 from "../../assets/gallery/FY-20-21/6.png"
import A7 from "../../assets/gallery/FY-20-21/7.png"
import A8 from "../../assets/gallery/FY-20-21/8.png"
import A9 from "../../assets/gallery/FY-20-21/9.png"
import A10 from "../../assets/gallery/FY-20-21/10.png"
import A11 from "../../assets/gallery/FY-20-21/11.png"
import A12 from "../../assets/gallery/FY-20-21/12.png"
import A13 from "../../assets/gallery/FY-20-21/13.png"
import A14 from "../../assets/gallery/FY-20-21/14.png"
import A15 from "../../assets/gallery/FY-20-21/15.png"
import A16 from "../../assets/gallery/FY-20-21/16.png"
import A17 from "../../assets/gallery/FY-20-21/17.png"

// 2021 - 2022
import B1 from "../../assets/gallery/FY-21-22/1.jpg"
import B2 from "../../assets/gallery/FY-21-22/2.jpg"
import B3 from "../../assets/gallery/FY-21-22/3.jpg"
import B4 from "../../assets/gallery/FY-21-22/4.jpg"
import B5 from "../../assets/gallery/FY-21-22/5.jpg"
import B6 from "../../assets/gallery/FY-21-22/6.jpg"
import B7 from "../../assets/gallery/FY-21-22/7.jpg"
import B8 from "../../assets/gallery/FY-21-22/8.jpg"
import B9 from "../../assets/gallery/FY-21-22/9.jpg"
import B10 from "../../assets/gallery/FY-21-22/10.jpg"
import B11 from "../../assets/gallery/FY-21-22/11.jpg"
import B12 from "../../assets/gallery/FY-21-22/12.jpg"
import B13 from "../../assets/gallery/FY-21-22/13.jpg"
import B14 from "../../assets/gallery/FY-21-22/14.jpg"
import B15 from "../../assets/gallery/FY-21-22/15.jpg"
import B16 from "../../assets/gallery/FY-21-22/16.jpg"
import B17 from "../../assets/gallery/FY-21-22/17.jpg"
import B18 from "../../assets/gallery/FY-21-22/18.jpg"
import B19 from "../../assets/gallery/FY-21-22/19.jpg"
import B20 from "../../assets/gallery/FY-21-22/20.jpg"

// 2022 - 2023
import C1 from "../../assets/gallery/FY-22-23/1.png"
import C2 from "../../assets/gallery/FY-22-23/2.jpeg"
import C3 from "../../assets/gallery/FY-22-23/3.jpeg"
import C4 from "../../assets/gallery/FY-22-23/4.jpeg"
import C5 from "../../assets/gallery/FY-22-23/5.jpeg"
import C6 from "../../assets/gallery/FY-22-23/6.jpeg"
import C7 from "../../assets/gallery/FY-22-23/7.jpeg"
import C8 from "../../assets/gallery/FY-22-23/8.jpeg"
import C9 from "../../assets/gallery/FY-22-23/9.jpeg"
import C10 from "../../assets/gallery/FY-22-23/10.jpeg"
import C11 from "../../assets/gallery/FY-22-23/11.jpeg"
import C12 from "../../assets/gallery/FY-22-23/12.jpeg"
import C13 from "../../assets/gallery/FY-22-23/13.jpeg"
import C14 from "../../assets/gallery/FY-22-23/14.jpeg"
import C15 from "../../assets/gallery/FY-22-23/15.jpeg"
import C16 from "../../assets/gallery/FY-22-23/16.jpeg"
import C17 from "../../assets/gallery/FY-22-23/17.jpeg"
import C18 from "../../assets/gallery/FY-22-23/18.jpeg"
import C19 from "../../assets/gallery/FY-22-23/19.jpeg"
import C20 from "../../assets/gallery/FY-22-23/20.jpeg"
import C21 from "../../assets/gallery/FY-22-23/21.jpeg"
import C22 from "../../assets/gallery/FY-22-23/22.jpeg"
import C23 from "../../assets/gallery/FY-22-23/23.jpeg"
import C24 from "../../assets/gallery/FY-22-23/24.jpeg"
import C25 from "../../assets/gallery/FY-22-23/25.jpeg"
import C26 from "../../assets/gallery/FY-22-23/26.jpeg"
import C27 from "../../assets/gallery/FY-22-23/27.jpeg"

export const F2020_2021 = [
    {
        original: A1,
        thumbnail: A1,
    },
    {
        original: A2,
        thumbnail: A2,
    },
    {
        original: A3,
        thumbnail: A3,
    },
    {
        original: A4,
        thumbnail: A4,
    },
    {
        original: A5,
        thumbnail: A5,
    },
    {
        original: A6,
        thumbnail: A6,
    },
    {
        original: A7,
        thumbnail: A7,
    },
    {
        original: A8,
        thumbnail: A8,
    },
    {
        original: A9,
        thumbnail: A9,
    },
    {
        original: A10,
        thumbnail: A10,
    },
    {
        original: A11,
        thumbnail: A11,
    },
    {
        original: A12,
        thumbnail: A12,
    },
    {
        original: A13,
        thumbnail: A13,
    },
    {
        original: A14,
        thumbnail: A14,
    },
    {
        original: A15,
        thumbnail: A15,
    },
    {
        original: A16,
        thumbnail: A16,
    },
    {
        original: A17,
        thumbnail: A17,
    }

]

export const F2021_2022 = [
    {
        original: B1,
        thumbnail: B1,
    },
    {
        original: B2,
        thumbnail: B2,
    },
    {
        original: B3,
        thumbnail: B3,
    },
    {
        original: B4,
        thumbnail: B4,
    },
    {
        original: B5,
        thumbnail: B5,
    },
    {
        original: B6,
        thumbnail: B6,
    },
    {
        original: B7,
        thumbnail: B7,
    },
    {
        original: B8,
        thumbnail: B8,
    },
    {
        original: B9,
        thumbnail: B9,
    },
    {
        original: B10,
        thumbnail: B10,
    },
    {
        original: B11,
        thumbnail: B11,
    },
    {
        original: B12,
        thumbnail: B12,
    },
    {
        original: B13,
        thumbnail: B13,
    },
    {
        original: B14,
        thumbnail: B14,
    },
    {
        original: B15,
        thumbnail: B15,
    },
    {
        original: B16,
        thumbnail: B16,
    },
    {
        original: B17,
        thumbnail: B17,
    },
    {
        original: B18,
        thumbnail: B18,
    },
    {
        original: B19,
        thumbnail: B19,
    },
    {
        original: B20,
        thumbnail: B20,
    }

]
export const F2022_2023 = [
    {
        original: C1,
        thumbnail: C1,
    },
    {
        original: C2,
        thumbnail: C2,
    },
    {
        original: C3,
        thumbnail: C3,
    },
    {
        original: C4,
        thumbnail: C4,
    },
    {
        original: C5,
        thumbnail: C5,
    },
    {
        original: C6,
        thumbnail: C6,
    },
    {
        original: C7,
        thumbnail: C7,
    },
    {
        original: C8,
        thumbnail: C8,
    },
    {
        original: C9,
        thumbnail: C9,
    },
    {
        original: C10,
        thumbnail: C10,
    },
    {
        original: C11,
        thumbnail: C11,
    },
    {
        original: C12,
        thumbnail: C12,
    },
    {
        original: C13,
        thumbnail: C13,
    },
    {
        original: C14,
        thumbnail: C14,
    },
    {
        original: C15,
        thumbnail: C15,
    },
    {
        original: C16,
        thumbnail: C16,
    },
    {
        original: C17,
        thumbnail: C17,
    },
    {
        original: C18,
        thumbnail: C18,
    },
    {
        original: C19,
        thumbnail: C19,
    },
    {
        original: C20,
        thumbnail: C20,
    },
    {
        original: C21,
        thumbnail: C21,
    },
    {
        original: C22,
        thumbnail: C22,
    },
    {
        original: C23,
        thumbnail: C23,
    },
    {
        original: C24,
        thumbnail: C24,
    },
    {
        original: C25,
        thumbnail: C25,
    },
    {
        original: C26,
        thumbnail: C26,
    },
    {
        original: C27,
        thumbnail: C27,
    }

]

